import React, { FC } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useMuiController } from "../../../form/MuiController/MuiController";
import { PlaceFormFields } from "./formSchema";
import { AutocompleteInputProps } from "@sinch/components/form/AutocompleteInput/types";
import { CountrySelect as SharedCountrySelect } from "@sinch/components/application/CountrySelect/CountrySelect";

export const CountrySelect: FC = () => {
  const { t } = useTranslation();
  const { setValue } = useFormContext<PlaceFormFields>();

  const {
    field: { onChange, ...field },
  } = useMuiController({
    name: "country",
    required: true,
  });

  const handleChange: AutocompleteInputProps["onChange"] = (e) => {
    setValue("region", "");
    onChange(e);
  };

  return (
    <SharedCountrySelect
      {...field}
      FormHelperTextProps={{
        "data-cy": "locationCountryError",
      }}
      label={t("country")}
      onChange={handleChange}
      placeholder={t("choose")}
    />
  );
};
